import React from "react";
import { Link } from "react-router-dom";
import { Container } from "../ui/Container";
import { cn } from "../../utils/cn";

const MAIN_SITE_URL = "https://setgoinnovations.com";

export interface HeaderProps {
  className?: string;
}

const Header: React.FC<HeaderProps> = ({ className }) => {
  return (
    <header
      className={cn(
        "fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm border-b border-secondary-200",
        className
      )}
    >
      <Container size="xl" padding="md">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center space-x-2 text-xl font-bold text-secondary-900 hover:text-primary-500 transition-colors"
          >
            <img src="/logo.png" alt="Setgo Innovations" className="w-6 h-6" />
            <span>Partner Registration</span>
          </Link>
          <nav className="flex items-center space-x-4">
            <Link
              to="/"
              className="text-secondary-700 hover:text-primary-500 font-medium transition-colors"
            >
              Registration Form
            </Link>
            <Link
              to="/dashboard"
              className="text-secondary-700 hover:text-primary-500 font-medium transition-colors"
            >
              Dashboard
            </Link>
            <Link
              to="/login"
              className="text-secondary-700 hover:text-primary-500 font-medium transition-colors"
            >
              Partner Login
            </Link>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-secondary-700 hover:text-primary-500 font-medium transition-colors"
            >
              Setgo Innovations
            </a>
          </nav>
        </div>
      </Container>
    </header>
  );
};

export { Header };
